import e from"./_overArg.js";var r=e(Object.keys,Object);export{r as default};
//# sourceMappingURL=_nativeKeys.js.map
